<bdcp-products-search-bar></bdcp-products-search-bar>

<div class="container">
  <div class="top">
    <div class="header">
      Alle Produkte
    </div>
    <div class="sub-header">
      Bitte wählen Sie eine Gerätekategorie aus:
    </div>
  </div>
  <hr class="top-categories-seperator">
  <div bdFxLayout="row wrap" bdFxLayoutAlign="space-between start" class="categories">
    <div *ngFor="let category of productCategories" bdFxFlex="1 1 calc(25% - 12px * 3 / 4)" (click)="search(category)"
      class="category">
      <div class="image">
        <img [src]="category.imageSource" />
      </div>
      <div class="name">{{category.name}}</div>
    </div>
  </div>
</div>
